<button
  class="activity-log-opener btn btn-link"
  [ngbPopover]="popoverBody"
  [popoverTitle]="popoverTitle"
  #popover="ngbPopover"
  container="body"
  triggers="manual"
  [autoClose]="'outside'"
  [popoverClass]="'history-popover-wrap'"
  (click)="$event.stopPropagation(); togglePopover(popover)"
>
  <svg class="align-items-start icon-comment-bubble">
    <use xlink:href="#comment-bubble-ellipsis"></use>
  </svg>
  <span class="visuallyhidden">{{ 'label_show_issue_audit_history' | translate }}</span>
</button>

<ng-template #popoverBody>
  <div class="history-timeline">
    @for (item of issueStatusHistories$ | async; track item) {
      <div>
        <app-view-flaw-status-history-item [historyItem]="item" [expanded]="true"></app-view-flaw-status-history-item>
      </div>
    }
  </div>
</ng-template>

<ng-template #popoverTitle>
  <div class="history-timeline-title py-3">
    <h2 class="mb-0">
      {{ 'label_activity_log' | translate }}
    </h2>
    <button class="btn btn-link p-0" (click)="popover.close()">
      <svg aria-hidden="true" focusable="false" viewBox="0 0 8 8"><use href="#cross-solid"></use></svg>
      <span class="visuallyhidden">{{ 'close_modal_dialog' | translate }}</span>
    </button>
  </div>
</ng-template>
